<!-- Popup.vue -->
<template>
  <div v-if="visible" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto" @click.self="closePopup">
    <div class="bg-white p-6 shadow-lg max-w-md w-full max-h-screen overflow-y-auto h-4/5 border-8 border-deliRed">
      <slot></slot>
      <button
        @click="closePopup"
        class="mt-4 bg-deliRed text-white px-4 py-2 rounded hover:bg-deliLightCoral transition"
      >
        Close
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close"],
  methods: {
    closePopup() {
      this.$emit("close");
    },
  },
};
</script>
